import { isGradePassed, trim, yearsFromNow, daysFromYearsAgo, filterZeroArrays, getCoursesFromColleges, empty, totalCourseCredits, getTotalLoggedHours, handleize, coursesWithCreditsTotal } from '@/lib/utils'
import moment from 'moment'

export default {

  computed: {
    greExempted () {
      if (this.savedSchool.gre_exempt_masters_doctoral_degrees === true) {
        return this.hasMastersForDoctorate
      }
      return false
    },
    hasMastersForDoctorate () {
      return this.allowedUserColleges.some((college) => {
        if (handleize(college.degree) !== 'completed' || empty(college.degree)) return false
        return ['masters', 'doctorate'].includes(handleize(college.college_degree_awarded))
      })
    },
    hasMCATExcemption () {
      if (this.savedSchool.mcat_accepted_instead_gre === true) {
        const completedExams = this.completedMCATExams
        return completedExams.length
      }
      return false
    },
    completedMCATExams () {
      return this.$store.getters.userExams.filter(({ examStatus, date, exam_type, mcat_total_score }) => {
        if (!examStatus) return false
        if (empty(this.savedSchool.mcat_minimum_score_required)) return handleize(examStatus) === 'completed' && handleize(exam_type) === 'mcat'

        const minScore = Number(this.savedSchool.mcat_minimum_score_required)
        const userScore = Number(mcat_total_score)
        return handleize(examStatus) === 'completed' && userScore >= minScore
      })
    },
    greScoreCondition () {
      if (this.greExempted) return true
      if (this.hasMCATExcemption) return true
      const completedExams = this.completedGREExams
      const checkConditions = [
        ['gre_minimum_verbal_score', 'gre_verbal_reasoning_score'],
        ['gre_minimum_quantitative_score', 'gre_quantitative_reasoning_score'],
        ['gre_minimum_writing_score', 'gre_analytical_writing_score'],
        ['gre_minimum_combined_score', 'gre_combined_score']
      ]
      // If school has missing data return true
      if (checkConditions.every((checkCondition) => empty(this.savedSchool[checkCondition[0]]))) {
        if (completedExams.length === 0) return false
        return true
      }

      return checkConditions.reduce((status, checkCondition) => {
        if (!status) return status
        return completedExams.some((exam) => {
          const examScore = Number(this.savedSchool[checkCondition[0]] ? this.savedSchool[checkCondition[0]] : 0)
          const userScore = Number(exam[checkCondition[1]])
          if ((isNaN(examScore) || empty(this.savedSchool[checkCondition[0]]))) {
            // !isNaN(userScore)
            return true
          }
          if (empty(userScore) || isNaN(userScore)) return false
          return userScore >= examScore
        })
      }, true)
    },
    grePercentileCondition () {
      if (this.greExempted) return true
      if (this.hasMCATExcemption) return true
      const completedExams = this.completedExams
      const checkConditions = [
        ['gre_minimum_verbal_percentile', 'gre_verbal_percentile_score'],
        ['gre_minimum_quantitative_percentile', 'gre_quantitative_percentile_score'],
        ['gre_minimum_writing_percentile', 'gre_analytical_percentile_score'],
        ['gre_minimum_combined_percentile', 'gre_combined_percentile_score']
      ]
      if (checkConditions.every((checkCondition) => empty(this.savedSchool[checkCondition[0]]))) {
        if (completedExams.length === 0) return false
        return true
      }

      return checkConditions.reduce((status, checkCondition) => {
        if (!status) return status
        return completedExams.some((exam) => {
          const examScore = Number(this.savedSchool[checkCondition[0]] ? this.savedSchool[checkCondition[0]] : 0)
          const userScore = Number(exam[checkCondition[1]])

          if ((isNaN(examScore) || empty(this.savedSchool[checkCondition[0]]))) {
            // !isNaN(userScore)
            return true
          }
          if (empty(userScore) || isNaN(userScore)) return false
          return userScore >= examScore
        })
      }, true)
    },
    completedExams () {
      return this.$store.getters.userExams.filter(({ examStatus, date, exam_type = '' }) => {
        if (empty(this.savedSchool.gre_minimum_year_completed)) return handleize(exam_type) === 'gre' && handleize(examStatus) === 'completed'
        const minYears = parseFloat(this.savedSchool.gre_minimum_year_completed) * 365
        if (!examStatus) return false
        return handleize(examStatus) === 'completed' && (moment().diff( moment(date, 'YYYY-MM-DD'), 'days' ) <= minYears)
      })
    },
    completedGREExams () {
      return this.completedExams.filter((exam) => exam.exam_type === 'GRE')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/requirementchecks/checkgremixin.js